import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {Day, Planning} from './plannig.model';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {PlanningHelperService} from './planning-helper-service';
import {Observable, throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlanningFOService extends DaoGeneric<Planning> {
  readonly url = `${environment.baseUrl}/suaps/planningfo/`;

  constructor(private httpClient: HttpClient,
              private planningHelper: PlanningHelperService) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }
  displayActivityDate(activity: Planning): string {
    return this.planningHelper.displayActivityDate(activity);
  }

  create(object, extraParams: Map<string, string> = null): Observable<any> {
    return throwError('méthode interdite');
  }

  update(object, key: string = 'id'): Observable<any> {
    return throwError('méthode interdite');
  }

  updateOrcreate(object, key: string = 'id'): Observable<any> {
    return throwError('méthode interdite');
  }

  delete(object, key: string = 'id', extraParams: Map<string, string> = null): Observable<any> {
    return throwError('méthode interdite');
  }

  deleteById(id, extraParams: Map<string, string> = null): Observable<any> {
    return throwError('méthode interdite');
  }

  patch(object, key: string = 'id'): Observable<Planning> {
    return throwError('méthode interdite');
  }

  getMesInscriptions(): Observable<Planning[]> {
    const url = `${environment.baseUrl}/suaps/mesinscriptions/`;
    return this.httpClient.get<Planning[]>(url);
  }
}
